import React from "react";
import StaticMenuCard from "src/components/atoms/StaticMenuCard";
import { useSelector, useDispatch } from "react-redux";
import { chooseMenu } from "src/store/global";

const StaticMenu = (props) => {
  const { toggleMenu, isOpen } = props;
  const dispatch = useDispatch();
  const menus = useSelector((state) => state.global.menus);

  const handleChooseMenu = (index) => {
    dispatch(chooseMenu({ index }));
    if (index === 4) {
      toggleMenu();
    }
  };

  return (
    <div className="relative z-50 bg-white">
      {menus.map((menu, index) => {
        return (
          <div onClick={() => handleChooseMenu(index)} key={`menu-${index}`} className="py-5">
            <StaticMenuCard {...menu} isOpen={index === 4 && isOpen} />
          </div>
        );
      })}
    </div>
  );
};

export default StaticMenu;
